import React from 'react';

class DownArrow extends React.Component {
  render(){
    return(
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="8.081632653061227"
        height="15.48979591836735"
      >

        <rect
          id="backgroundrect"
          width="100%"
          height="100%"
          x="0"
          y="0"
          fill="none"
          stroke="none"
          className=""
        />

        <g>
          <rect
            x="-1"
            y="-1"
            width="25"
            height="46"
            id="canvas_background"
            fill="none"
          />
          <g
            id="canvasGrid"
            display="none"
          >
            <rect
              id="svg_1"
              width="10"
              height="26"
              x="1"
              y="1"
              strokeWidth="0"
              fill="url(#gridpattern)"
            />
          </g>
        </g>
        <g
          className="currentLayer"
        >
          <path
            fill="#9b9b9b"
            stroke="#000"
            strokeWidth="0"
            strokeOpacity="null"
            opacity="0.5"
            d="m142.5,23 "
            id="svg_9"
            className=""
          />
          <g
            stroke="null"
            id="svg_10"
            className=""
          >
            <g
              stroke="null"
              id="svg_2"
            >
            {/* arrow */}
              <path
                stroke="#000"
                strokeWidth="0"
                strokeOpacity="null"
                d="m8.154953848979414,8.299279114074945 l-4.067272693236768,7.117727832096338 l-4.0672723395613435,-7.117727832096338 l8.134545032798112,0 z"
                id="svg_8"
              />
            </g>
          </g>
        </g>
      </svg>
    );
  }
}

export default DownArrow;
